(function() {
    "use strict";

    angular.module("dashboardApp").directive("imsHeader", Directive);

    Directive.$inject = [
        '$location',
        '$timeout',
        '$window',
        'AppSettings'
    ];



    function Directive(
        $location,
        $timeout,
        $window,
        AppSettings
    ) {


        function link($scope, element) {

            $scope.title = null;
            $scope.showBanner = true;


            $scope.goBack = function() {
                $window.history.back();
            };


            $scope.$on('$locationChangeStart', onLocationChange);



            function onLocationChange() {
                $timeout(function() {
                    var path = $location.path();

                    if (path.indexOf('/apps') === 0) {
                        $scope.title = 'Application List';
                        $scope.showBanner = false;

                    } else if (path.indexOf('/account') === 0) {
                        $scope.title = 'Account Manager';
                        $scope.showBanner = false;

                    } else if (path.indexOf('/usage-tracker') === 0) {
                        $scope.title = 'Usage Tracker';
                        $scope.showBanner = false;

                    } else {
                        $scope.title = 'Nexxus Performance';
                        $scope.showBanner = true;
                    }

                    $(document).prop('title', $scope.title);

                });

            }



            onLocationChange();

        }



        return {
            restrict: 'E',
            replace: true,
            scope: {
            },
            templateUrl: AppSettings.paths.html + '/common/layout/header.template.html',
            link: link
        };



    }


})();
